import {checkInn} from './innValidation';

/** Функция проверки ОГРН юрлиц, ОГРНИП ИП
 * @param {string} ogrnOgrnip - строка для проверки
 * @return boolean
 */
export const checkOgrnOgrnip = (ogrnOgrnip: string) => {
  //ОГРН в 13 знаков
  if (
    ogrnOgrnip.length === 13 &&
    ogrnOgrnip.slice(12, 13) === ((Number(ogrnOgrnip.slice(0, -1)) % 11) + '').slice(-1)
  ) {
    return true;

    //ОГРНИП в 15 знаков
  } else if (
    ogrnOgrnip.length === 15 &&
    ogrnOgrnip.slice(14, 15) === ((Number(ogrnOgrnip.slice(0, -1)) % 13) + '').slice(-1)
  ) {
    return true;
  } else {
    return false;
  }
};

export const validateOrgnOgnip = (ogrn: string | undefined, inn: string | undefined) =>
  !ogrn || ogrn.length === 0
    ? true
    : checkOgrnOgrnip(ogrn) && ogrn.length === 13 && inn && checkInn(inn) && inn.length === 12
      ? 'Нельзя указать ОГРН вместе с ИНН инд. предпринимателя'
      : checkOgrnOgrnip(ogrn) && ogrn.length === 15 && inn && checkInn(inn) && inn.length === 10
        ? 'Нельзя указать ОГРНИП вместе с ИНН юр. лица'
        : checkOgrnOgrnip(ogrn) ||
          (ogrn.length === 13 && 'Некорректный ОГРН') ||
          (ogrn.length === 15 && 'Некорректный ОГРНИП');
